import React from "react";
import classNames from "classnames";
import styles from "./divider.module.scss";

export type DividerProps = {
  className?: string;
  type?: "horizontal";
} & React.HTMLAttributes<HTMLHRElement>;

const Divider = ({
  className,
  type = "horizontal",
  ...props
}: DividerProps) => (
  <hr
    className={classNames(styles.divider, className)}
    data-type={type}
    {...props}
  />
);

export default Divider;
